import React, { createContext, useState, useContext } from 'react'

export const PodcastContext = createContext(null)

export const PodcastProvider = ({ children }) => {
    const [audioUrl, setAudioUrl] = useState('')
    const [audioRef, setAudioRef] = useState(null)

    const value = {
        setAudioUrl,
        audioRef,
    }

    return <PodcastContext.Provider value={value}>{children}</PodcastContext.Provider>
}

export const usePodcast = () => useContext(PodcastContext)

// Singleton

export const generatePodcast = (url, title, image) => {
    const item = { url: url, title: title, image: image }
    return item
}

// class PodcastSingleton {
//     constructor() {
//         if (!PodcastSingleton.instance) {
//             this.currentVideoRef = null;
//             PodcastSingleton.instance = this;
//         }
//         return PodcastSingleton.instance;
//     }

//     setCurrentVideoRef(videoRef) {
//         if (this.currentVideoRef && this.currentVideoRef !== videoRef) {
//             this.currentVideoRef.pauseAsync();
//         }
//         this.currentVideoRef = videoRef;
//     }

//     getCurrentVideoRef() {
//         return this.currentVideoRef;
//     }

//     playCurrentVideo() {
//         if (this.currentVideoRef) {
//             this.currentVideoRef.playAsync();
//         }
//     }

//     pauseCurrentVideo() {
//         if (this.currentVideoRef) {
//             this.currentVideoRef.pauseAsync();
//         }
//     }
// }




async function playSound(url) {
    const [sound, setSound] = useState(null)
    if (sound === null) {
        await Audio.setAudioModeAsync({
            playsInSilentModeIOS: true,
        })
        const { sound, status } = await Audio.Sound.createAsync({ uri: url }, { shouldPlay: true })
        setSound(sound)

        onAudioRef(sound)
        if (status.isLoaded) {
            await sound.playAsync().then(() => {
                setIsPlaying(true)
            })
        }
    } else {
        await sound.playAsync()
        setIsPlaying(true)
    }
}

async function stopsound() {
    await sound.setPositionAsync()
    await sound.pauseAsync().then((playbackStatus) => {
        setIsPlaying(false)
    })
}
